export const categoryImages = {
  pizza: [
    'https://images.unsplash.com/photo-1650327381366-c6dc88f8b9fe?crop=entropy&cs=srgb&fm=jpg&q=85',
    'https://images.unsplash.com/photo-1554136812-8b7875b188b2?crop=entropy&cs=srgb&fm=jpg&q=85',
    'https://images.unsplash.com/photo-1642870615633-c3a134f29396?crop=entropy&cs=srgb&fm=jpg&q=85',
    'https://images.unsplash.com/photo-1566843972705-1aad0ee32f88?crop=entropy&cs=srgb&fm=jpg&q=85',
    'https://images.unsplash.com/photo-1574071318508-1cdbab80d002?crop=entropy&cs=srgb&fm=jpg&q=85',
    'https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?crop=entropy&cs=srgb&fm=jpg&q=85',
    'https://images.unsplash.com/photo-1593560708920-61dd98c46a4e?crop=entropy&cs=srgb&fm=jpg&q=85',
    'https://images.unsplash.com/photo-1604382355076-af4b0eb60143?crop=entropy&cs=srgb&fm=jpg&q=85',
    'https://images.unsplash.com/photo-1628840042765-356cda07504e?crop=entropy&cs=srgb&fm=jpg&q=85',
    'https://images.unsplash.com/photo-1513104890138-7c749659a591?crop=entropy&cs=srgb&fm=jpg&q=85',
    'https://images.unsplash.com/photo-1571407970349-bc81e7e96d47?crop=entropy&cs=srgb&fm=jpg&q=85',
    'https://images.unsplash.com/photo-1590947132387-155cc02f3212?crop=entropy&cs=srgb&fm=jpg&q=85',
  ],
  appetizers: [
    'https://images.unsplash.com/photo-1762631934944-1607dfccfe6b?crop=entropy&cs=srgb&fm=jpg&q=85',
    'https://images.unsplash.com/photo-1734774924912-dcbb467f8599?crop=entropy&cs=srgb&fm=jpg&q=85',
    'https://images.unsplash.com/photo-1630384060421-cb20d0e0649d?crop=entropy&cs=srgb&fm=jpg&q=85',
    'https://images.unsplash.com/photo-1604908176997-125f25cc6f3d?crop=entropy&cs=srgb&fm=jpg&q=85',
  ],
  salads: [
    'https://images.unsplash.com/photo-1739436776460-35f309e3f887?crop=entropy&cs=srgb&fm=jpg&q=85',
    'https://images.unsplash.com/photo-1722032617357-7b09276b1a8d?crop=entropy&cs=srgb&fm=jpg&q=85',
    'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?crop=entropy&cs=srgb&fm=jpg&q=85',
    'https://images.unsplash.com/photo-1546793665-c74683f339c1?crop=entropy&cs=srgb&fm=jpg&q=85',
    'https://images.unsplash.com/photo-1607532941433-304659e8198a?crop=entropy&cs=srgb&fm=jpg&q=85',
    'https://images.unsplash.com/photo-1540420773420-3366772f4999?crop=entropy&cs=srgb&fm=jpg&q=85',
  ],
  dinners: [
    'https://images.unsplash.com/photo-1719670712556-638018bd8238?crop=entropy&cs=srgb&fm=jpg&q=85',
    'https://images.unsplash.com/photo-1666599207792-d25938831199?crop=entropy&cs=srgb&fm=jpg&q=85',
    'https://images.pexels.com/photos/2116094/pexels-photo-2116094.jpeg?auto=compress&cs=tinysrgb&w=940',
    'https://images.unsplash.com/photo-1627858034922-72a657d6b3c2?crop=entropy&cs=srgb&fm=jpg&q=85',
  ],
  wings: [
    'https://images.unsplash.com/photo-1734987942068-a1a459d65d3d?crop=entropy&cs=srgb&fm=jpg&q=85',
    'https://images.unsplash.com/photo-1712286928542-17af515d3dcd?crop=entropy&cs=srgb&fm=jpg&q=85',
    'https://images.unsplash.com/photo-1608039755401-742074f0548d?crop=entropy&cs=srgb&fm=jpg&q=85',
  ],
  soups: [
    'https://images.unsplash.com/photo-1547592166-23ac45744acd?crop=entropy&cs=srgb&fm=jpg&q=85',
    'https://images.unsplash.com/photo-1604908176997-125f25cc6f3d?crop=entropy&cs=srgb&fm=jpg&q=85',
  ],
  wraps: [
    'https://images.pexels.com/photos/5779364/pexels-photo-5779364.jpeg?auto=compress&cs=tinysrgb&w=940',
    'https://images.unsplash.com/photo-1597579018905-8c807adfbed4?crop=entropy&cs=srgb&fm=jpg&q=85',
  ],
  calzones: [
    'https://images.unsplash.com/photo-1642870615633-c3a134f29396?crop=entropy&cs=srgb&fm=jpg&q=85',
    'https://images.unsplash.com/photo-1566843972705-1aad0ee32f88?crop=entropy&cs=srgb&fm=jpg&q=85',
    'https://images.unsplash.com/photo-1513104890138-7c749659a591?crop=entropy&cs=srgb&fm=jpg&q=85',
    'https://images.unsplash.com/photo-1574071318508-1cdbab80d002?crop=entropy&cs=srgb&fm=jpg&q=85',
  ],
  catering: [
    'https://images.unsplash.com/photo-1555244162-803834f70033?crop=entropy&cs=srgb&fm=jpg&q=85',
    'https://images.unsplash.com/photo-1467003909585-2f8a72700288?crop=entropy&cs=srgb&fm=jpg&q=85',
  ],
};

export const getImageForItem = (categoryId, index) => {
  const images = categoryImages[categoryId] || categoryImages.pizza;
  return images[index % images.length];
};
